// UK formatting helpers: Sat 4 Oct · 7:30pm · £1,234.50 · 04/10/2026

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value) ? null : value;
  const text = String(value).trim();
  let match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  match = text.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (match) return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
  const parsed = new Date(text);
  return isNaN(parsed) ? null : parsed;
};

export const toISODate = (value) => {
  const date = toDate(value);
  if (!date) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

// 04/10/2026
export const ukShort = (value) => {
  const date = toDate(value);
  if (!date) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};

// Sat 4 Oct (adds the year when it is not this year)
export const ukDate = (value, { withYear } = {}) => {
  const date = toDate(value);
  if (!date) return '—';
  const showYear = withYear ?? date.getFullYear() !== new Date().getFullYear();
  return `${DAYS[date.getDay()]} ${date.getDate()} ${MONTHS[date.getMonth()]}${showYear ? ` ${date.getFullYear()}` : ''}`;
};

// Sat 4 October 2026
export const ukDateLong = (value) => {
  const date = toDate(value);
  if (!date) return '—';
  return `${DAYS[date.getDay()]} ${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
};

// 7:30pm  (from "19:30", "7:30 PM", "19:30:00")
export const ukTime = (value) => {
  if (!value) return '';
  const text = String(value).trim();
  const match = text.match(/^(\d{1,2})[:.](\d{2})\s*(am|pm|AM|PM)?/) || text.match(/^(\d{1,2})()\s*(am|pm|AM|PM)?/);
  if (!match) return text;
  let hour = Number(match[1]);
  const minutes = match[2] || '00';
  const lower = text.toLowerCase();
  // "2:30-4pm" has its am/pm at the end, and bookings before 8 are evening ones
  let suffix = (match[3] || '').toLowerCase();
  if (!suffix) {
    if (lower.includes('pm')) suffix = 'pm';
    else if (lower.includes('am')) suffix = 'am';
    else if (hour < 8) suffix = 'pm';
  }
  if (suffix === 'pm' && hour < 12) hour += 12;
  if (suffix === 'am' && hour === 12) hour = 0;
  const period = hour >= 12 ? 'pm' : 'am';
  let display = hour % 12;
  if (display === 0) display = 12;
  return minutes === '00' ? `${display}${period}` : `${display}:${minutes}${period}`;
};

// £1,234.50
export const money = (value, dash = '—') => {
  if (value === null || value === undefined || value === '') return dash;
  const number = Number(value);
  if (isNaN(number)) return dash;
  const sign = number < 0 ? '\u2212' : '';
  return `${sign}£${Math.abs(number).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// −39.7%
export const pct = (value, dash = '—') => {
  if (value === null || value === undefined || value === '') return dash;
  const number = Number(value);
  if (isNaN(number)) return dash;
  return `${number < 0 ? '\u2212' : ''}${Math.abs(number)}%`;
};

export const firstName = (name) => String(name || '').trim().split(/\s+/)[0] || 'there';
